import React from 'react';
import AdminDashboard from '../teacher/admin-dashboard';

const Support = () => {
  return (
    <div>
    <AdminDashboard />  
    </div>
  );
}

export default Support;
